import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import {
    getAPIPath,
    getMenu
} from "../../../../utils/getDomainData";
import { BlocksRenderer } from "../../../../components/BlockRenderer";

const SMSAdmissionMain = () => {
    const [data, setData] = useState([]);
    const [profileData, SetProfileData] = useState(null);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];

    const { fontSize } = useFontSize();

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.admission, setData);
        fetchData(getAPIPath(currentDomain)?.profile, SetProfileData);
    }, [currentDomain]);

    const admissionData = data?.data?.attributes;

    return (
        <React.Fragment>
            <Helmet>
                <title>SMS Admissions | School of Management Studies | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="Admission requirements and courses offered at School of Management Studies, JNTUA. MBA programs and eligibility criteria."
                />
                <meta
                    name="keywords"
                    content="SMS Admissions, MBA, JNTUA, School of Management Studies, ICET, Eligibility, FinTech, Business Data Analytics"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .admission-section {
                        padding: 50px 0;
                        background: #fff;
                    }
                    
                    .admission-card {
                        background: #fff;
                        border-radius: 15px;
                        box-shadow: 0 10px 30px rgba(0,0,0,0.1);
                        padding: 40px;
                        margin-bottom: 30px;
                        border: 1px solid #f0f0f0;
                    }
                    
                    .admission-title {
                        color: #ff6600;
                        font-weight: 600;
                        margin-bottom: 30px;
                        padding-bottom: 15px;
                        border-bottom: 3px solid #ff6600;
                        font-size: calc(${fontSize}px + 8px);
                    }
                    
                    .eligibility-section {
                        background: #f8f9fa;
                        padding: 40px 0;
                    }
                    
                    .eligibility-card {
                        background: #fff;
                        border-radius: 12px;
                        padding: 35px;
                        box-shadow: 0 8px 25px rgba(0,0,0,0.08);
                        border-left: 5px solid #ff6600;
                    }
                    
                    .eligibility-title {
                        color: #333;
                        font-weight: 600;
                        margin-bottom: 25px;
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .eligibility-list {
                        list-style: none;
                        padding: 0;
                        margin: 0;
                    }
                    
                    .eligibility-list li {
                        padding: 12px 0 12px 30px;
                        position: relative;
                        color: #555;
                        line-height: 1.6;
                        border-bottom: 1px solid #f0f0f0;
                    }
                    
                    .eligibility-list li:last-child {
                        border-bottom: none;
                    }
                    
                    .eligibility-list li:before {
                        content: "✓";
                        position: absolute;
                        left: 0;
                        top: 12px;
                        color: #ff6600;
                        font-weight: bold;
                        font-size: 18px;
                    }
                    
                    .courses-section {
                        padding: 50px 0;
                        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                    }
                    
                    .courses-grid {
                        display: grid;
                        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                        gap: 25px;
                        margin-top: 30px;
                    }
                    
                    .course-card {
                        background: #fff;
                        border-radius: 12px;
                        padding: 30px 25px;
                        text-align: center;
                        box-shadow: 0 5px 20px rgba(0,0,0,0.1);
                        transition: all 0.3s ease;
                        border: 2px solid transparent;
                        position: relative;
                        overflow: hidden;
                    }
                    
                    .course-card:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        height: 4px;
                        background: linear-gradient(90deg, #ff6600, #ff8533);
                    }
                    
                    .course-card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 10px 30px rgba(255, 102, 0, 0.2);
                        border-color: #ff6600;
                    }
                    
                    .course-icon {
                        width: 60px;
                        height: 60px;
                        background: linear-gradient(135deg, #ff6600, #ff8533);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 auto 20px;
                        color: white;
                        font-size: 24px;
                        font-weight: bold;
                    }
                    
                    .course-title {
                        color: #333;
                        font-weight: 600;
                        margin-bottom: 15px;
                        font-size: calc(${fontSize}px + 4px);
                    }
                    
                    .course-description {
                        color: #666;
                        font-size: calc(${fontSize}px - 1px);
                        line-height: 1.5;
                    }
                    
                    .section-header {
                        text-align: center;
                        margin-bottom: 40px;
                    }
                    
                    .section-title {
                        color: #333;
                        font-weight: 700;
                        margin-bottom: 15px;
                        font-size: calc(${fontSize}px + 12px);
                    }
                    
                    .section-subtitle {
                        color: #666;
                        font-size: calc(${fontSize}px + 2px);
                        max-width: 600px;
                        margin: 0 auto;
                        line-height: 1.6;
                    }
                    
                    .highlight-text {
                        color: #ff6600;
                        font-weight: 600;
                    }
                `}
            </style>

            <div className="pageTopOffset">
                <SiteBreadcrumb pageTitle="SMS Admissions" />

                {getMenu(currentDomain)}

                {/* Admission Requirements Section */}
                <div className="admission-section">
                    <div className="container">
                        <div className="section-header">
                            <h1 className="section-title">
                                Join the <span className="highlight-text">School of Management Studies</span> and embark on your journey towards excellence in business education
                            </h1>
                            <p className="section-subtitle">
                                Discover our innovative programs, experienced faculty, and vibrant campus community.
                            </p>
                        </div>

                        {admissionData?.title && (
                            <div className="admission-card">
                                <h2 className="admission-title">{admissionData.title}</h2>
                                <BlocksRenderer content={admissionData.eligibilityText} />
                            </div>
                        )}
                    </div>
                </div>

              
                {/* Courses Offered Section */}
                {admissionData?.CoursesOffered && admissionData.CoursesOffered.length > 0 && (
                    <div className="courses-section">
                        <div className="container">
                            <div className="section-header">
                                <h2 className="section-title">
                                    Courses <span className="highlight-text">Offered</span>
                                </h2>
                                <p className="section-subtitle">
                                    Explore our comprehensive range of MBA programs designed to shape future business leaders
                                </p>
                            </div>

                            <div className="courses-grid">
                                {admissionData.CoursesOffered.map((course, index) => (
                                    <div key={index} className="course-card">
                                        <div className="course-icon">
                                            {course.text.includes('FinTech') ? '💰' :
                                                course.text.includes('Analytics') ? '📊' : '🎓'}
                                        </div>
                                        <h4 className="course-title">{course.text}</h4>
                                        <p className="course-description">
                                            {course.text.includes('FinTech')
                                                ? 'Specialized program focusing on Financial Technology and Digital Banking innovations'
                                                : course.text.includes('Analytics')
                                                    ? 'Advanced program combining business acumen with data science and analytics'
                                                    : 'Comprehensive Master of Business Administration program covering all aspects of modern business management'
                                            }
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

              
            </div>

            <Accreditation />
            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />
            <ScrollToTop scrollClassName="scrollup orange-color" />
            <SearchModal />
        </React.Fragment>
    );
};

export default SMSAdmissionMain;